const styles = theme => ({
  root: {
    position: 'absolute',
    marginLeft: 84,
    marginTop: 41,
    [theme.breakpoints.up('sm')]: {


    },
    [theme.breakpoints.up('md')]: {

    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Item/components/Omit/styles.js